<template>
  <div class="checklist">

    <div v-if="loadingChecklist" style="text-align: center; padding: 2rem;">
      <h3>Carregando checklist...</h3>
      <div class="spinner"></div> 
    </div>
    <!-- Nav Bar de Checklist de Engenharia -->
    <div v-else class="frame-checklist">
      <div>
        <nav v-if="configInputs==0">
          <div class="nav" role="tablist">
            <a @click.prevent="click_checklist" :class="classCheck">Check list</a>
            <a @click.prevent="click_itemNOK" :class="classCheck2" v-if="hasItemsNOK">Itens Não/NOK</a>
          </div>
        </nav>
        <nav v-if="configInputs!=0">
          <div class="navview" role="tablist">
            <a @click.prevent="click_checklist" :class="classCheck3">Check list</a>
            <a @click.prevent="click_itemNOK" :class="classCheck4" v-if="hasItemsNOK">Itens Não/NOK</a>
          </div>
        </nav>
      </div>
      <!--  Check List -->
      <div v-if="Show_Check == true">
        <!-- Inicializando Tabela -->
        <table-lite
          :is-hide-paging="true"
          :is-slot-mode="true"
          :is-loading="isLoading"
          :columns="columns"
          :rows="rows"
          :total="totalRecordCount"
          :sortable="sortable"
          @do-search="doSearch"
          @is-finished="isLoading = false"
        >
          <!-- Colunas -->
          <!-- Descrição -->
          <template v-slot:description="data">
            <div class="compponents-conditions">
            <h2>{{ DataChecklist[data.value.number].description.slice(3) }}</h2>
            </div>
          </template>
          <!-- Opção -->
          <template v-slot:opcao="data">
            <select
              v-model="DataChecklist[data.value.number].opcao"
              :disabled="configInputs"
              :class="[
                'field',
                {
                  error: ValidationAndCondition(
                    DataChecklist[data.value.number].opcao,
                    DataChecklist[data.value.number].opcao
                  ),
                },
              ]" style=" margin-right: 0.8rem; width: 13rem!important;"
            >
              <option value="" disabled selected v-if="configInputs==0">Selecione a opção</option>
              <option value="" disabled selected v-if="configInputs!=0">Não selecionada</option>
              <option value="1">Sim</option>
              <option value="2">N/A</option>
              <option value="3">N/Ok</option>
              <option value="4">Não</option>
              <option value="5">Ok</option>
            </select>
          </template>
          <!-- Observação -->
          <template v-slot:observacao="data" >
            <div style=" display: flex; align-items: center; justify-content: center;">
              <textarea
                :disabled="configInputs"
                class="field2"
                v-model="DataChecklist[data.value.number].observacao"
                :placeholder= "configInputs ? 'Não informado' : 'Digite seu comentário'"
              ></textarea>
            </div>
          </template>
        </table-lite>
        <!-- Ocultar após testes -->
        <!-- {{DataChecklist}} -->
      </div>
      <!-- Lista de Itens Não/OK -->
      <div v-else>
        <!-- Inicializando Tabela -->
        <div v-if="!isLoadingTableNok">
          <table-lite
            :is-slot-mode="true"
            :is-loading="isLoadingNok"
            :columns="columns2"
            :rows="rowsNowOk"
            :total="totalRecordCountNok"
            :sortable="sortable"
            @do-search="doSearch_NaoOK"
            @is-finished="isLoadingNok = false"
          >
            <!-- Colunas -->
            <!-- Description -->
            <template v-slot:description="data">
              <div class="compponents-conditions">
              <h2>{{ this.DataItemsNok[data.value.number].description.slice(3) }}</h2>
              </div>
            </template>
            <!-- Observação -->
            <template v-slot:observacao="data">
              <div class="compponents-conditions">
              <h2>{{ DataItemsNok[data.value.number].observacao }}</h2>
            </div>
            </template>
          </table-lite>
        </div>
        <div v-else>
          <h3>Carregando checklist...</h3>
          <div class="spinner"></div> 
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, requiredIf } from "@vuelidate/validators";
import TableLite from "./Table-Simple.vue";
import { GetFindAllDataItem } from "../../controllers/ItemsChecklist/GetFindAllDataItem";
import dayjs from "dayjs";

// Orden de dados em forma Crescente
const sampleData1 = (offst, limit) => {
  offst = offst + 1;

  let data = [];
  for (let i = offst; i <= limit; i++) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

//Orden de dados em forma Decrescente
const sampleData2 = (offst, limit) => {
  let data = [];
  for (let i = limit; i > offst; i--) {
    data.push({
      description: i - 1,
      number: i - 1,
    });
  }
  return data;
};

export default {
  name: "App",
  components: { TableLite },

  props: {
    configInputs: Number,
  },
  async created() {
    const res = await GetFindAllDataItem();
    if (res != undefined) {
      this.items = res.data.list;
    }

    this.doSearch();

    if (this.configInputs != 0) {
      await this.ConstructViewRRIM();
      this.$emit("setDataChecklist", this.DataChecklist);
    }
    // Inicalização Checklist em 0 a 10 dos Items do Banco

    // Criando Objeto Checklist para manipulalo.
    if (this.configInputs == 0) {
      this.items.map((element, index) => {
        this.createChecklist(element.ID, element.DESC);
      });
    }
    this.doSearch();
    this.loadingChecklist = false;
  },
  data() {
    return {
      loadingChecklist: true,
      Check: true,
      Check_2: false,
      Show_Check: true,
      DataChecklist: [],
      v$: useVuelidate(),
      DataItemsNok: [],
      // Items que devem vir do banco de dados
      items: [],
      isLoading: false,
      isLoadingTableNok: true,
      isLoadingNok: false,

      columns: [
        {
          label: "Descrição das Condições dos Componentes",
          field: "description",
          width: "auto",
          sortable: true,
        },
        {
          label: "Status",
          field: "opcao",
          width: "auto",
          sortable: true,
        },
        {
          label: "Comentário",
          field: "observacao",
          width: "auto",
          sortable: true,
        },
      ],
      columns2: [
        {
          label: "Descrição das Condições dos Componentes",
          field: "description",
          width: "auto",
          sortable: true,
        },
        {
          label: "Observação",
          field: "observacao",
          width: "auto",
          sortable: true,
        }
      ],


      rows: [],
      rowsNowOk: [],

      totalRecordCount: 0,
      totalRecordCountNok: 0,

      sortable: {
        order: "id",
        sort: "asc",
      },
    };
  },

  computed: {
    ValidationAndCondition() {
      return (option, data) => {
        if (option === "1" && data == "") {
          return true;
        }

        return false;
      };
    },
    ValidationItemSim() {
      return (option, data, status) => {
        if (option === "1" && (data == "" || status == "")) {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", Swal.stopTimer);
              toast.addEventListener("mouseleave", Swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "info",
            text: "Preenchimento Obrigatario de Data e Status!",
          });

          return true;
        }
      };
    },
    classCheck() {
    return this.Show_Check ? 'check-ativo' : 'check-inativo';
  },
    classCheck2() {
      return !this.Show_Check ? 'check-ativo red' : 'check-inativo';
    },
    classCheck3() {
      return !this.Show_Check ? 'check-ativo-view' : 'check-inativo-view';
    },
    classCheck4() {
      return !this.Show_Check ? 'check-inativo-view' : 'check-ativo-view';
    },
      hasItemsNOK() {
    return this.DataChecklist.some(item => item.opcao === "3");
  },

  },

  methods: {
    // Montagem de filro e limite do checklist
    doSearch() {
    this.isLoading = true;
    setTimeout(() => {
      this.rows = this.DataChecklist.map((_, index) => ({ 
        description: index,
        number: index 
      }));
      this.totalRecordCount = this.DataChecklist.length;
      this.isLoading = false;
    }, 600);
  },

  // Modifique para carregar todos os itens NOK
  doSearch_NaoOK() {
    setTimeout(() => {
      this.rowsNowOk = this.DataItemsNok.map((_, index) => ({
        description: index,
        number: index
      }));
      this.totalRecordCountNok = this.DataItemsNok.length;
    }, 600);
  },

    //Criando o Checklist
    createChecklist(id, description) {
      const obj = {
        id: id,
        description: description,
        opcao: "",
        data: "campo não usado",
        observacao: "",
        status: true,
      };

      this.DataChecklist.push(obj);
    },
    async ConstructViewRRIM() {
      const dataQuery = await this.$store.getters.$GetDataAllRRIM;
      dataQuery.MoldeFechado[0].checklist.map((element) => {
        let description = this.items.find((data) => data.ID == element.ID_LIST);

        this.DataChecklist.push({
          id: element.ID,
          description: description.DESC,
          opcao: element.OPCAO,
          data: this.ReformDate(element.DATA),
          observacao: element.OBSERVACAO,
          status: element.STATUS,
        });
      });
    },
    //  Enviando dados Não Ok do Checklist para a tabela de Itens Não/Ok
    updateItemsNaoOk() {
      const data = this.DataChecklist;
      const dataNOK = [];
      data.map((element) => {
        // Condicional para lista itens Não / Ok
        if (element.opcao == "3") {
          dataNOK.push(element);
        }
      });
      this.DataItemsNok = dataNOK;
    },

    // Interação com usuarios
    click_checklist() {
      this.Show_Check = true;
      this.Check = "nav-item nav-link font-weight-bold maozinha active";
      this.Check_2 = "nav-item nav-link font-weight-bold maozinha red  ";
    },
    click_itemNOK() {
      this.updateItemsNaoOk(); 
      this.doSearch_NaoOK(0, 10, "description", "asc"); // Obs : Reajuste de limite e filtro da quantidade atualizada de Itens Não/Ok
      this.Show_Check = false;
      this.Check = "nav-item nav-link font-weight-bold maozinha ";
      this.Check_2 = "nav-item nav-link font-weight-bold maozinha active red";
      this.isLoadingTableNok = true;
      setTimeout(() => {
        this.isLoadingTableNok = false;
      }, 800);
    },
    ReformDate(date) {
      if (date === null) {
        return null;
      }
      const dataFormatada = dayjs(date).add(1, "days").format("YYYY-MM-DD");
      return dataFormatada;
    },
  },

  watch: {
    //  Monitoração de Obj Checklist
    DataChecklist: {
      handler() {
      this.doSearch(); // Atualiza a lista completa quando os dados mudam
    },
      deep: true,
      immediate: true,
      handler(newValue, oldValue) {
        
        this.updateItemsNaoOk();
        this.$emit("setDataChecklist", newValue);
        this.$store.commit("MutationSetDataChecklistUpdate", newValue);
      },
    },
  },
};
</script>
<style scoped>

.frame-checklist {
  border-radius: 1rem;
  padding: 1rem 0rem;
}

.spinner {
  border: 4px solid rgba(0,0,0,0.1);
  border-left-color: var(--green);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spin 0.8s linear infinite;
  margin: 1rem auto;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.nav {
  display: flex;
  margin: 1rem 0rem;
  gap: 0.8rem!important;
}

.navview {
  display: flex;
  justify-content: center;
  padding: 0.5rem 0rem;
  margin: 0rem 0rem 1rem;
  gap: 1rem;
}

.check-ativo {
  color: white!important;
  padding: 0.7rem 1.2rem;
  background-color: var(--green);
  border-radius: 0.5rem;
}

.check-ativo-view {
  color: var(--font_color)!important;
  padding: 0.7rem 1.2rem;
  border: 2px solid var(--font_color)!important;
  border-radius: 0.5rem;
  cursor: pointer;
}

.check-inativo {
  color: var(--green)!important;
  padding: 0.57rem 1.07rem!important;
  border: 2px solid var(--green)!important;
  border-radius: 0.5rem!important;
  cursor: pointer;
}

.check-inativo-view {
  color: var(--white)!important;
  padding: 0.7rem 1.2rem!important;
  background-color: var(--font_color);
  border-radius: 0.5rem!important;
  cursor: pointer;
}

a.check-inativo-view {
  display:flex;
  align-items: center;
}

.check-ativo-view:hover {
  font-weight: 800;
}


.check-inativo:hover {
  color: green!important;
  border-color: green!important;
}

.red {
  color: rgb(255, 255, 255) !important;
}

* {
  color: var(--font_color)!important;
}

.field {
  display: flex;
  align-items: center!important;
  border-radius: 10px!important;
  border: 1px solid #d9d9d9b3;
  height:2.5rem!important;
  padding: 0rem 1rem;
  color: var(--font_color);
  overflow: auto; 
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  margin-top: 0.5rem;
  width: 100%!important;
  
}

.field2{
  resize: none;
  display: flex;
  align-items: center!important;
  border-radius: 10px!important;
  border: 1px solid #d9d9d9b3;
  height:2.5rem!important;
  padding: 0.5rem 1rem;
  color: var(--font_color);
  overflow: auto; 
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  margin-top: 0.5rem;
  width: 25rem!important; 
}

.field option {
  color: var(--font_color);
  background-color: #f0f0f0;
  border-radius: 5rem!important;
}


.field option:hover {
  background-color: #e0e0e0!important;
}

.field option:checked {
  background-color: var(--font_color); 
  border-radius: 5rem!important;
  color: white!important; 
}

.compponents-conditions h2{
  display: flex;
  align-items: center!important;
  line-height: 1rem;
  text-align: left!important;
  font-weight: 500!important;
  font-size: 0.85rem;
}

.field:hover {
  border: 1px solid var(--input_hover)!important;
  transition: border-color 0.5s ease;
}

.field2:hover{
  border: 1px solid var(--input_hover)!important;
  transition: border-color 0.5s ease;
}

.field:focus {
  border: 1px solid var(--green)!important;
}

.field2:focus {
  border: 1px solid var(--green)!important;
}

.field::placeholder{
  color: rgb(65, 62, 62)!important;
}

.field::-webkit-scrollbar {
  display: none;
}

.compponents-conditions {
  display: flex;
  align-items: center;
  border-radius: 10px!important;
  border: 1px solid #D9D9D9;
  height:2.5rem!important;
  padding: 0rem 1rem;
  color: var(--font_color);
  overflow: auto; 
  scrollbar-width: none; 
  -ms-overflow-style: none; 
  margin-top: 0.5rem;
  font-weight: 100!important;
  width: 25rem!important;
  margin-right: 1rem!important;
}

.check-ativo {
  color: green;
  font-weight: bold;
}

.check-inativo {
  color: red;
  opacity: 0.5;
}

@media (max-width: 700px) {
  .compponents-conditions {
  width: 13rem!important;
}
  .field2 {
    width: 13rem!important;
  }
}
</style>
